export default function () {
  var self = this;
  self.modalData = ko.observable();
}

